import styled from 'styled-components';

export const AboutUsWrapper = styled.div`
`;
